import { render, staticRenderFns } from "./Portofolio.vue?vue&type=template&id=67c9d67a&"
import script from "./Portofolio.vue?vue&type=script&lang=js&"
export * from "./Portofolio.vue?vue&type=script&lang=js&"
import style0 from "./Portofolio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports